import { FilterMultiSelect } from "@/components/common/FilterMultiSelect";
import { useUsers } from "@/components/pages/users/hooks/useUsers";
import { Role } from "@/types/user";
import React from "react";
import { useTranslation } from "react-i18next";

export interface FrontDeskFilterProps {
  ids: string[];
  onChange: (ids: string[]) => void;
  placeholder?: string;
}

const FrontDeskFilter: React.FC<FrontDeskFilterProps> = ({
  ids,
  onChange,
  placeholder,
}) => {
  const { t } = useTranslation();
  const { data: users } = useUsers({
    roles: [Role.FRONT_DESK],
  });

  return (
    <FilterMultiSelect
      className="w-[200px] justify-between"
      options={
        users?.map((user) => ({
          value: user.id,
          label:
            `${user.firstName || ""} ${user.lastName || ""}`.trim() ||
            user.email ||
            "",
        })) || []
      }
      placeholder={
        placeholder ??
        t("feedbacks.filters.frontDesk", "Filter feedbacks by front desk")
      }
      value={ids}
      onValueChange={onChange}
    />
  );
};

export default FrontDeskFilter;
